import React, { useState, useEffect } from 'react';
import { X, FileEarmarkText, FileEarmarkImage, FileEarmarkPdf } from 'react-bootstrap-icons';
import { Modal } from 'react-bootstrap';
import './FileCard.css';

interface FileCardProps {
  file: File;
  onRemove: () => void;
}

const FileCard: React.FC<FileCardProps> = ({ file, onRemove }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const isImage = file.type.toLowerCase().includes('image');

  useEffect(() => {
    if (isImage) {
      const url = URL.createObjectURL(file);
      setImageUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [file, isImage]);

  const getFileIcon = () => {
    const fileType = file.type.toLowerCase();

    if (fileType.includes('pdf')) {
      return <FileEarmarkPdf size={16} />;
    } else if (fileType.includes('image')) {
      return <FileEarmarkImage size={16} />;
    } else {
      return <FileEarmarkText size={16} />;
    }
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0B';

    const k = 1024;
    const sizes = ['B', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return Math.round(bytes / Math.pow(k, i)) + sizes[i];
  };

  const handleCardClick = (e: React.MouseEvent) => {
    // Don't trigger if clicking the remove button
    if ((e.target as HTMLElement).closest('.file-card-remove')) {
      return;
    }
    if (isImage) {
      setShowPreview(true);
    }
  };

  return (
    <>
      <div
        className={`file-card ${isImage ? 'file-card-clickable' : ''}`}
        onClick={handleCardClick}
      >
      <div className="file-card-header">
        <div className="file-card-icon">
          {getFileIcon()}
        </div>
        <button
          className="file-card-remove"
          onClick={onRemove}
          aria-label="Remove file"
          type="button"
        >
          <X size={16} />
        </button>
      </div>
      <div className="file-card-name" title={file.name}>
        {file.name}
      </div>
      <div className="file-card-size">
        {formatFileSize(file.size)}
      </div>
    </div>

    {isImage && imageUrl && (
      <Modal show={showPreview} onHide={() => setShowPreview(false)} centered size="lg" className='file-card-modal'>
        <Modal.Header closeButton>
          <Modal.Title>{file.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <img
            src={imageUrl}
            alt={file.name}
            style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        </Modal.Body>
      </Modal>
    )}
  </>
  );
};

export default FileCard;
